import axios from 'axios';

const baseURL = '/api/organizations';

export const getVisitsByOrgId = async (orgId) => {
	if (!orgId) {
		return;
	}

	try {
		return await axios.get(`${baseURL}/${orgId}/visits`);
	} catch (error) {
		throw new Error(error);
	}
};

export const getShareProfileBodyContentByOrgId = async (orgId) => {
	try {
		return await axios.get(
			`${baseURL}/${orgId}/share_profiles/field_attributes`
		);
	} catch (error) {
		throw new Error(error);
	}
};

export const getSentInvitations = async (orgId) => {
	try {
		return await axios.get(`${baseURL}/${orgId}/share_profiles`);
	} catch (error) {
		throw new Error(error);
	}
};

export const postSentInvitations = async (orgId, payload) => {
	try {
		return await axios.post(`${baseURL}/${orgId}/share_profiles`, payload);
	} catch (error) {
		throw new Error(error);
	}
};
